const Dialogs = {

    init() {
        this.component = '[component].Dialog2';
        this.el = $(this.component);

        if (!this.el.length) {
            return;
        }

        this.header = this.el.find('header');
        this.buttonHolder = this.el.find('.copyOfButton');

        this.buttonRevert = this.el.find("button.cancel");
        //this.buttonAction = this.el.find(".copyOfButton button");

        this.start();
        this.bind();
    },

    start() {
    },
    bind() {
        this.buttonRevert.on("click", function (el) {
            Dialogs.hide();
        });

        $(document).on("click", ".copyOfButton button, .copyOfButton a", function (el) {
            Dialogs.hide();
        });
    },

    setHeader(header) {
        this.header.html(header);
    },

    setButton(el) {
        let button = el.clone();
        let buttonDataAttr = button.data();

        button.removeClass("confirm");

        this.buttonHolder.html(button);

        if (buttonDataAttr.dialogtext) {
            this.buttonHolder.find("button").text(buttonDataAttr.dialogtext)
        }
    },

    show() {
        this.el.addClass("visible");
    },

    hide() {
        this.el.removeClass("visible");
    }
}
export default Dialogs;